import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import {
    get_all_bookings,
    cancel_booking,
    convert_booking,
} from "../../../../Controllers/Sales/Bookings";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Sales/Bookings/tables";
import headers from "../../../../Data/Tables/Sales/Bookings/headers";
import Loadercomponent from "../../../../Componets/Loader";
import moment from "moment";

const BookingsTable = () => {
    const navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [header, setHeader] = useState(headers);
    const [body, setBody] = useState();

    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalCount: 0,
        totalPages: 0,
    });

    const statusLabel = (status) => {
        const map = {
            0: { label: "Pending", color: "bg-yellow-100 text-yellow-700" },
            1: { label: "Confirmed", color: "bg-blue-100 text-blue-700" },
            2: { label: "Converted", color: "bg-green-100 text-green-700" },
            3: { label: "Cancelled", color: "bg-red-100 text-red-700" },
        };
        const s = map[status] || { label: "-", color: "" };
        return (
            <span className={`px-2 py-1 rounded text-xs font-medium ${s.color}`}>
                {s.label}
            </span>
        );
    };

    const paginationdata = (data) => {
        let headerdata = {};
        header?.components?.map((value) => {
            headerdata[value.name] = value.value;
        });
        fetchData({
            ...data,
            search: headerdata?.search,
            sort: headerdata?.sort,
            status: headerdata?.status,
            date: headerdata?.date,
        });
    };

    const formdata = (data) => {
        let page = data?.search ? pagination?.currentPage : 1;
        fetchData({
            ...data,
            currentPage: page,
            totalCount: pagination?.totalCount,
            totalPages: pagination?.totalPages,
        });
    };

    const actiondata = (data) => {
        let headerdata = {};
        headers?.components?.map((value) => {
            headerdata[value.name] = value.value;
        });
        fetchData({
            ...data,
            search: headerdata?.search,
            sort: headerdata?.sort,
            status: headerdata?.status,
            date: headerdata?.date,
            currentPage: pagination?.currentPage,
            totalCount: pagination?.totalCount,
            totalPages: pagination?.totalPages,
        });
    };

    const handleCancel = async (id) => {
        const result = await cancel_booking({ id });
        if (result?.status) {
            toast?.success(result?.message);
            actiondata({});
        } else {
            toast?.error(result?.message);
        }
    };

    const handleConvert = async (id) => {
        const result = await convert_booking({ id });
        if (result?.status) {
            toast?.success(result?.message);
            // navigate to invoice form pre-filled with booking data
            navigate(`/app/sales/invoices/add?booking=${id}`);
        } else {
            toast?.error(result?.message);
        }
    };

    const fetchData = async (tabledata) => {
        try {
            setLoader(true);

            const data = {
                search: tabledata?.search,
                sort: tabledata?.sort,
                status: tabledata?.status,
                date: tabledata?.date,
                page: tabledata?.currentPage,
            };

            const result = await get_all_bookings(data);

            if (result?.status) {
                let rows = [];

                result?.data?.data?.map((value) => {
                    const isActive = value?.status === 0 || value?.status === 1;

                    rows?.push({
                        path: `/app/sales/bookings/view/${value?._id}`,
                        Number: `#BK-${value?.number}`,
                        Customer: value?.customer?.name || "-",
                        Date: moment(value?.date)?.format("DD-MM-YYYY"),
                        Expiry: value?.expiry_date
                            ? moment(value?.expiry_date)?.format("DD-MM-YYYY")
                            : "-",
                        Salesman: value?.salesman?.name || "-",
                        Deposit: value?.deposit?.length
                            ? `${value.deposit.reduce((s, d) => s + (d.amount || 0), 0).toFixed(3)}`
                            : "-",
                        Total: `${parseFloat(value?.total || 0)?.toFixed(3)}`,
                        Status: statusLabel(
                            value?.booking_status === "converted" ? 2 :
                                value?.booking_status === "cancelled" ? 3 :
                                    value?.status
                        ),
                        Action: (
                            <div className="flex gap-2 items-center">
                                {/* Convert to Invoice */}
                                {isActive && (
                                    <button
                                        type="button"
                                        className="text-xs px-2 py-1 border border-green-500 text-green-600 rounded hover:bg-green-50"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleConvert(value?._id);
                                        }}
                                    >
                                        Convert
                                    </button>
                                )}
                                {/* Cancel */}
                                {isActive && (
                                    <button
                                        type="button"
                                        className="text-xs px-2 py-1 border border-red-400 text-red-500 rounded hover:bg-red-50"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleCancel(value?._id);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                )}
                                <ActionButton
                                    edit={`/app/sales/bookings/edit/${value?._id}`}
                                    id={value?._id}
                                    api="delete-booking"
                                    actiondata={actiondata}
                                    headers={header}
                                />
                            </div>
                        ),
                    });
                });

                setBody(rows);
                setPagination({
                    currentPage: result?.data?.currentPage,
                    totalCount: result?.data?.totalCount,
                    totalPages: result?.data?.totalPages,
                });
                setLoader(false);
            } else {
                setLoader(false);
                if (result?.status_code == 403) {
                    window.location.href = "/unauthorized";
                } else {
                    toast?.error(result?.message);
                }
            }
        } catch (errors) {
            toast?.error(errors?.message);
        }
    };

    const headerReset = () => {
        let componentData = [];
        headers?.components?.map((value) => {
            componentData?.push({ ...value, value: null });
        });
        setHeader({ ...headers, components: componentData });
    };

    useEffect(() => {
        fetchData();
        headerReset();
    }, []);

    return (
        <Header headers={header} setHeaders={setHeader} formdata={formdata}>
            <Loadercomponent loader={loader}>
                <Table
                    head={tables}
                    body={body}
                    pagination={pagination}
                    paginationdata={paginationdata}
                />
            </Loadercomponent>
        </Header>
    );
};

export default BookingsTable;